import React from 'react';
import Select from 'react-select';

class ReactMultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(val) {
    const values = [];
    for (let index = 0; index < val.length; index++) {
      values.push(val[index].value);
    }
    this.props.handleOperation(values);
  }
  render() {
    return (<div>
      <Select options={this.props.options} onChange={this.handleSelect}
        multi={true} value={this.props.values}
      />
    </div>);
  }
}

ReactMultiSelect.propTypes = {
  'handleOperation': React.PropTypes.func,
  'options': React.PropTypes.array,
  'values': React.PropTypes.array,
};

export default ReactMultiSelect;



// WEBPACK FOOTER //
// ./assets/src/frontend/helper/reactMultiSelect.js